import { ChainId } from '../types';
import { NATIVE_TOKEN_ADDRESS } from './constants';
export const ADDRESS_BY_CHAIN_L2 = {
    [ChainId.ZK_EVM]: {
        // to find the token l2 addresses, log in useCustomToken, getDepositTokenL2Address
        WCRO: '0xBCaA34FF9D5BFD0d948b18Cf6Bf39a882F4a1cBD',
        // it's the native token, no erc20. but need an identifier.
        ZkCRO: NATIVE_TOKEN_ADDRESS,
        Bridge: '0x309429DE3621992Cb0ab8982A448c9Cc5c38405b',
        CorgiAI: '0x54447f5314568Aac87d6ee9F11D2B7ad0D837413',
        WBTC: '0xD65E5DbA71231D35A5802bA83dC6cB6746c9758d',
        FUL: '0xFB3338E2cA713B344D6A45B36525c3db156e492F',
        USDC: '0xaa5b845F8C9c047779bEDf64829601d8B264076c',
        YbETH: '0xf226a595b83056ff3D26b827e3d5b0896E4392a9',
        ZkETH: '0x271602A97027ee1dd03b1E6e5dB153eB659A80b1',
        YbUSD: '0xb1Ece5b548766215272BAFCfa36396B06Cd9e4C9',
        ZkUSD: '0x5b91e29Ae5A71d9052620Acb813d5aC25eC7a4A2', // vUSD
        YbTokenBot: '0xe1f5d6D5180Df2eAAf9806F23f4b104866558D4C',
        ETH: '0x898B3560AFFd6D955b1574D87EE09e46669c60eA',
        VEthRewarder: '0x5F254945A318f7ca93496320767E6b640aB9f730',
        VUsdRewarder: '0xFcD9cA1968Af3274a5e327dBfa7C80a99a0c0f52',
        wzkCRO: '0xc1bf55ee54e16229d9b369a5502bfe5fc9f20b6d',
        H2: '0xcaf2fd3f47e7f46e99f74be579b2cc2233f33ef8',
        MERY: '0x6a03942cf08ca3c6fc036b31070073b322a494d6',
        MOON: '0xc80b437c4c0f9c74cfb2e2d063a58ffb4f82d4f0',
        AMPLY: '0x66b1E42B2D5bce3D701Efa3c86Cc334d80cEEfaB',
        TokenDistributor: '0xcfeeb3aac754be31b4dc77ba29bc2b32f48216d2',
        AGENTFUN: '0x18d40Bd95e34d1a4fcaf9027Db11F6988e5B860A',
    },
    [ChainId.ZK_EVM_TEST]: {
        WCRO: '0x08A6E713f6A9Baa9af5170729448F286e5cc6a2a',
        ZkCRO: NATIVE_TOKEN_ADDRESS,
        Bridge: '0x637eA67543CaaE41023dcffE3004953f5b6a6Cdf',
        WBTC: '',
        CorgiAI: '',
        FUL: '0x70fA5F5C1D11B1642896C98A974A091A1884443b',
        USDC: '0xcd22fec4653544ac8ca6971fbc553c9cd15ffad1',
        YbETH: '0x962871c572F9C542Bba2Aa94841516b621A08a79',
        ZkETH: '0x16a9Df93DEc0A559CdBAC00cB9E3a1BA91Bf6906',
        YbUSD: '0x7055ee4c4798871B618eD39f01F81906A48C4358',
        ZkUSD: '0x9553dA89510e33BfE65fcD71c1874FF1D6b0dD75', // vUSD
        YbTokenBot: '0x744b45Bb6f1AC0D52d7Df47d3bA810890844Cf63', //
        ETH: '0x11c3089837549884Aa9876AB726C892Ed10D263D',
        VEthRewarder: '0x1D7E44EB5196aB77B964392aB0e62150316dA3d0',
        VUsdRewarder: '0x6109220afB79b758d3cD7071b0f4eB1931783562',
        wzkCRO: '0xeD73b53197189BE3Ff978069cf30eBc28a8B5837',
        H2: '0x7c1dA4D7Ea2E6DAEE44052aD8764548A83b5F2bE',
        TokenDistributor: '0xea8996e7FF17D6Ae00Bd089AB9fd670d86B5239c',
        MERY: '',
        MOON: '',
        AMPLY: '',
        AGENTFUN: '',
    },
};
